import 'datatables.net';

function setComments(data) {
  const uniqueComments = [];
  const commentElements = data
    .filter(filterData => {
      if (filterData.comments && !uniqueComments.includes(filterData.comments)) {
        uniqueComments.push(filterData.comments);
        return true;
      }
      return false;
    })
    .map(
      commentData => `      
      <div class="comment">
        <p>${commentData.comments}</p>
        <div class="author">
          <div class="name">
            <h3>${commentData.agronomist || ''}</h3>
            <span>Seed Agronomist</span>
          </div>
        </div>
      </div>`
    );
  const commentsContainer = document.getElementById('comments-tab');
  commentsContainer.innerHTML = commentElements.join('');
}

function setInfoPanelData(data) {
  const cityState = document.getElementById('city-state');
  const salesRep = document.getElementById('sales-rep');
  const salesRepPhone = document.getElementById('sales-rep-phone');
  const agronomist = document.getElementById('agronomist');
  const agronomistPhone = document.getElementById('agronomist-phone');
  const population = document.getElementById('population');
  const irrigation = document.getElementById('irrigation');
  const rowSpacing = document.getElementById('row-spacing');
  const plantingDate = document.getElementById('planting-date');
  console.log(data);
  if (cityState && data.city && data.state) {
    cityState.innerHTML = `${data.city}, ${data.state}`;
  }
  if (salesRep && data.sales_rep) {
    salesRep.innerHTML = `Agronomic Solutions Advisor: ${data.sales_rep}`;
  }
  if (salesRepPhone && data.sales_rep_phone) {
    salesRepPhone.innerHTML = `ASA Phone Number: ${data.sales_rep_phone}`;
  }
  if (agronomist && data.agronomist) {
    agronomist.innerHTML = `Seed Agronomist: ${data.agronomist}`;
  }
  if (agronomistPhone && data.agronomist_phone) {
    agronomistPhone.innerHTML = `Seed Agronomist Phone Number: ${data.agronomist_phone}`;
  }
  if (population && data.population) {
    population.innerHTML = `Planting Population: ${data.population}`;
  }
  if (irrigation && data.irrigation) {
    irrigation.innerHTML = `Irrigation: ${data.irrigation}`;
  }
  if (rowSpacing && data.row_spacing) {
    rowSpacing.innerHTML = `Row Spacing: ${data.row_spacing}`;
  }
  if (plantingDate && data.planting_date) {
    plantingDate.innerHTML = `Planting Date: ${data.planting_date}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tableElement = document.querySelector('#data-table');
  if (!tableElement) {
    console.error('#datatable element not found.');
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const yearParam = urlParams.get('year');
  const cropParam = urlParams.get('crop');
  const companyParam = urlParams.get('company');
  const trialParam = urlParams.get('trial');

  let apiUrl = 'https://basf-mw.in10t.solutions/fields';
  const params = [];
  if (yearParam) params.push(`year=${encodeURIComponent(yearParam)}`);
  if (cropParam) params.push(`crop=${encodeURIComponent(cropParam)}`);
  if (companyParam) params.push(`company=${encodeURIComponent(companyParam)}`);
  if (trialParam) params.push(`trial=${encodeURIComponent(trialParam)}`);
  if (params.length > 0) {
    apiUrl += `?${params.join('&')}`;
  }

  const yieldButtonTab = document.getElementById('yield-button');
  const commentsButtonTab = document.getElementById('comments-button');
  const yieldTab = document.getElementById('yield-tab');
  const commentsTab = document.getElementById('comments-tab');

  $(yieldButtonTab).on('click', () => {
    yieldTab.classList.remove('hidden-tab');
    commentsTab.classList.add('hidden-tab');
    yieldButtonTab.classList.add('active');
    commentsButtonTab.classList.remove('active');
  });

  $(commentsButtonTab).on('click', () => {
    commentsButtonTab.classList.add('active');
    yieldButtonTab.classList.remove('active');

    commentsTab.classList.remove('hidden-tab');
    yieldTab.classList.add('hidden-tab');
  });

  $.ajax({
    url: apiUrl,
    dataType: 'json',
    success: data => {
      const features = data.features;

      features.sort((a, b) => a.properties.refined_mg - b.properties.refined_mg);

      const properties = features.map(feature => {
        return feature.properties;
      });

      const yieldChart = features.map(item => ({
        brand: item.properties.brand,
        variety: item.properties.variety,
        yield: item.properties.yield
      }));

      const maxYield = features.reduce((max, item) => Math.max(max, item.properties.yield), -Infinity);

      const yieldChartElement = document.getElementById('yield-chart');
      features.forEach(item => {
        const itemElement = document.createElement('div');

        const barWidth = ((item.properties.yield * 100) / maxYield).toFixed(0);
        itemElement.innerHTML = `
          <div class="product"> 
            <span class="variety">${item.properties.variety}</span>
            <span class="bar-container">
              <span class="bar ${item.properties.brand === 'Xitavo' && 'xitavo'}" style="width: ${barWidth}%;">${
          item.properties.yield
        }</span>
            </span>
          </div>
        `;

        yieldChartElement.appendChild(itemElement);
      });

      const columns = [
        { data: 'brand', title: 'Brand' },
        {
          data: 'variety',
          title: 'Variety',
          render: item => {
            if (item.toLowerCase().startsWith('x')) {
              return `<a href="https://www.xitavosoybeanseed.com/xitavo-products" target="_blank">${item}</a>`;
            }
            return item;
          }
        },
        { data: 'refined_mg', title: 'RM' },
        { data: 'trait', title: 'Technology' },
        { data: 'yield', title: 'Yield' },
        { data: 'yield_rank', title: 'Yield Rank' }
      ];

      const dataTable = $('#data-table').DataTable({
        data: properties,
        columns,
        scrollX: true,
        paging: false,
        ordering: false
      });

      dataTable.columns.adjust().draw();

      function alignTableHeadBody() {
        const tableHeaders = document.querySelectorAll('.dataTables_scrollHeadInner th');
        const tableCells = document.querySelectorAll('.dataTables_scrollBody tr:first-child td');
        if (tableCells.length !== tableHeaders.length) {
          return;
        }

        tableCells.forEach((cell, i) => {
          cell.style.minWidth = '0px';
          cell.style.width = `auto`;
          tableHeaders[i].style.minWidth = '0px';
          tableHeaders[i].style.width = `auto`;
          const widerWidth =
            cell.offsetWidth > tableHeaders[i].offsetWidth ? cell.offsetWidth : tableHeaders[i].offsetWidth;
          setTimeout(() => {
            cell.style.width = `${widerWidth}px`;
            cell.style.minWidth = `${widerWidth}px`;
            tableHeaders[i].style.width = `${widerWidth - 30}px`;
            tableHeaders[i].style.minWidth = `${widerWidth - 30}px`;
          }, 100);
        });
      }
      alignTableHeadBody();
      window.addEventListener('resize', alignTableHeadBody);

      // fill top form
      setInfoPanelData(properties[0]);
      // fill comments
      setComments(properties);
    },
    error: (xhr, status, error) => {
      console.error(xhr, status, error);
    }
  });
});
